export enum CertificateTableNamesEnum {
  'Overview' = 'Overview',
  'Log' = 'Log',
}
